var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getInstallBaseDetailsAPI, installbaseDetailsGetUrl, SearchFilterTypeURL } from "../../../api/url";
import { showLoader } from "../../../redux/commonSlice";
import { getByIdAPI, getListAPI, setReducerState } from "../../../redux/crudSlice";
import { store } from "../../../store/store";
import { getPartDetailsAPI } from "../../spareIssue/services/entity";
import { WorkPurchaseInvoicePagingAPIUrl } from "../../workPurchaseInvoice/services/entity";
import { getCustomerByIdAPI, getJobCardDetailAPI, SpareIssueReturnKeys } from "./entity";
var dispatch = store.dispatch;
export var SPRPagingAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? SpareIssueReturnKeys.Paging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? WorkPurchaseInvoicePagingAPIUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var getSearchResultAPIcall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _result$payload, _result$payload2, _result$payload3, _result$payload$value, _result$payload4, _result$payload5, _a, key, _b, request, _c, url, result;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                _a = params.key, key = _a === void 0 ? SpareIssueReturnKeys.SearchDetails : _a, _b = params.request, request = _b === void 0 ? params : _b, _c = params.url, url = _c === void 0 ? getInstallBaseDetailsAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                result = _d.sent();
                if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success)
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                if (!(result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data && result !== null && result !== void 0 && (_result$payload3 = result.payload) !== null && _result$payload3 !== void 0 && (_result$payload3 = _result$payload3.value) !== null && _result$payload3 !== void 0 && (_result$payload3 = _result$payload3.data[0]) !== null && _result$payload3 !== void 0 && _result$payload3.JobCardId)) return [3 /*break*/, 3];
                return [4 /*yield*/, jobcardGetDetailsAPICall({
                        TransactionId: (_result$payload$value = result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.data[0]) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.JobCardId) !== null && _result$payload$value !== void 0 ? _result$payload$value : ""
                    })];
            case 2:
                _d.sent();
                _d.label = 3;
            case 3: return [2 /*return*/, result === null || result === void 0 || (_result$payload5 = result.payload) === null || _result$payload5 === void 0 ? void 0 : _result$payload5.value];
        }
    });
}); };
export var jobcardGetDetailsAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _result$payload6, _result$payload7, _result$payload8, _result$payload9, _result$payload10, _result$payload11, _result$payload12, _result$payload13, _a, key, _b, request, _c, url, result;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                _a = params.key, key = _a === void 0 ? SpareIssueReturnKeys.JobcardDetails : _a, _b = params.request, request = _b === void 0 ? params : _b, _c = params.url, url = _c === void 0 ? getJobCardDetailAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                result = _d.sent();
                if (result !== null && result !== void 0 && (_result$payload6 = result.payload) !== null && _result$payload6 !== void 0 && (_result$payload6 = _result$payload6.value) !== null && _result$payload6 !== void 0 && _result$payload6.success)
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                if (result !== null && result !== void 0 && (_result$payload7 = result.payload) !== null && _result$payload7 !== void 0 && (_result$payload7 = _result$payload7.value) !== null && _result$payload7 !== void 0 && _result$payload7.data && result !== null && result !== void 0 && (_result$payload8 = result.payload) !== null && _result$payload8 !== void 0 && (_result$payload8 = _result$payload8.value) !== null && _result$payload8 !== void 0 && (_result$payload8 = _result$payload8.data) !== null && _result$payload8 !== void 0 && _result$payload8.CustomerId)
                    getCustomerAssociationAPICall({
                        request: {
                            id: result === null || result === void 0 || (_result$payload9 = result.payload) === null || _result$payload9 === void 0 || (_result$payload9 = _result$payload9.value) === null || _result$payload9 === void 0 || (_result$payload9 = _result$payload9.data) === null || _result$payload9 === void 0 ? void 0 : _result$payload9.CustomerId
                        }
                    });
                if (result !== null && result !== void 0 && (_result$payload10 = result.payload) !== null && _result$payload10 !== void 0 && (_result$payload10 = _result$payload10.value) !== null && _result$payload10 !== void 0 && _result$payload10.data && result !== null && result !== void 0 && (_result$payload11 = result.payload) !== null && _result$payload11 !== void 0 && (_result$payload11 = _result$payload11.value) !== null && _result$payload11 !== void 0 && (_result$payload11 = _result$payload11.data) !== null && _result$payload11 !== void 0 && _result$payload11.InstallBaseId)
                    installbaseDetailsGetByIdAPICall({
                        request: {
                            id: result === null || result === void 0 || (_result$payload12 = result.payload) === null || _result$payload12 === void 0 || (_result$payload12 = _result$payload12.value) === null || _result$payload12 === void 0 || (_result$payload12 = _result$payload12.data) === null || _result$payload12 === void 0 ? void 0 : _result$payload12.InstallBaseId
                        }
                    });
                return [2 /*return*/, result === null || result === void 0 || (_result$payload13 = result.payload) === null || _result$payload13 === void 0 ? void 0 : _result$payload13.value];
        }
    });
}); };
export var getCustomerAssociationAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _res$payload2, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                _a = params.key, key = _a === void 0 ? SpareIssueReturnKeys.CustomerAssociationDetails : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getCustomerByIdAPI(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                if (res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && (_res$payload = _res$payload.value) !== null && _res$payload !== void 0 && _res$payload.success)
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                return [2 /*return*/, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value];
        }
    });
}); };
export var installbaseDetailsGetByIdAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload3, _res$payload4, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                _a = params.key, key = _a === void 0 ? SpareIssueReturnKeys.InstallbaseDetails : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? installbaseDetailsGetUrl(request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                if (res !== null && res !== void 0 && (_res$payload3 = res.payload) !== null && _res$payload3 !== void 0 && (_res$payload3 = _res$payload3.value) !== null && _res$payload3 !== void 0 && _res$payload3.success)
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                return [2 /*return*/, res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.value];
        }
    });
}); };
export var getPartDetailsAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload5, _res$payload6, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                dispatch(showLoader({
                    isLoaderOpen: true
                }));
                _a = params.key, key = _a === void 0 ? SpareIssueReturnKeys.PartDetails : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getPartDetailsAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                if (res !== null && res !== void 0 && (_res$payload5 = res.payload) !== null && _res$payload5 !== void 0 && (_res$payload5 = _res$payload5.value) !== null && _res$payload5 !== void 0 && _res$payload5.success)
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                return [2 /*return*/, res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.value];
        }
    });
}); };
export var getFilterTypeList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _result$payload14, _result$payload15, _result$payload16, _a, key, _b, request, _c, url, result, filterValues;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
                _a = params.key, key = _a === void 0 ? "" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? SearchFilterTypeURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                result = _d.sent();
                if (result !== null && result !== void 0 && (_result$payload14 = result.payload) !== null && _result$payload14 !== void 0 && (_result$payload14 = _result$payload14.value) !== null && _result$payload14 !== void 0 && _result$payload14.success)
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                filterValues = result === null || result === void 0 || (_result$payload15 = result.payload) === null || _result$payload15 === void 0 || (_result$payload15 = _result$payload15.data) === null || _result$payload15 === void 0 || (_result$payload15 = _result$payload15.find(function (item) { return (item === null || item === void 0 ? void 0 : item.Section) === "SPAREISSUEREQUEST"; })) === null || _result$payload15 === void 0 ? void 0 : _result$payload15.FilterValues;
                console.log("filterValues", filterValues);
                dispatch(setReducerState({
                    key: SpareIssueReturnKeys.SearchByTypeList,
                    value: filterValues
                }));
                return [2 /*return*/, result === null || result === void 0 || (_result$payload16 = result.payload) === null || _result$payload16 === void 0 ? void 0 : _result$payload16.value];
        }
    });
}); };
